import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { initialPath } from '~misc/paths';
import '~pages/PricesTableV2/components/Tabela/style.scss';

const HeaderCliente = ({ cliente }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();

    navigate(`${initialPath}/funil-de-obras/${cliente.clienteId}/acompanhamento-mapeamento`);
  };

  return (
    <span
      role="link"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick(e);
        }
      }}
      className="cursor-pointer hover:underline"
    >
      <span className="font-bold">{cliente.codigo}</span>{' - '}<span>{cliente.nome}</span>
    </span>
  );
};

HeaderCliente.propTypes = {
  cliente: PropTypes.object.isRequired,
};

const ActiveWorkContentTable = ({ obra }) => {
  return (
    <div className="table-container">
      <Table className="table">
        <colgroup>
          <col style={{ width: 260 }} />
          <col style={{ width: 180 }} />
          <col style={{ width: 180 }} />
          <col style={{ width: 180 }} />
          <col style={{ width: 180 }} />
          <col style={{ width: 120 }} />
        </colgroup>

        <Thead>
          <Tr>
            <Th>Grupo Produto</Th>
            <Th>Volume Faturado</Th>
            <Th>Volume Ganho</Th>
            <Th>Próx. Negociação</Th>
            <Th>Status</Th>
            <Th>%</Th>
          </Tr>
        </Thead>

        <Tbody>
          {(obra.produtos || []).map((row) => (
            <Tr key={row.id}>
              <Td>{row.grupoProduto}</Td>
              <Td>{row.volumeFaturado}</Td>
              <Td>{row.volumeNegociado}</Td>
              <Td>{row.dataNegociacao}</Td>
              <Td>{row.status}</Td>
              <Td>{row.porcentagem}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  );
};

ActiveWorkContentTable.propTypes = {
  obra: PropTypes.object.isRequired,
};

const ActiveWorkTable = ({ data = [] }) => {
  return (
    <main className="prices-table-table">
      <div className="container content">
        {(data || []).map((item) => (
          <Accordion key={item.clienteId} className="accordion" allowToggle defaultIndex={[0]}>
            <AccordionItem>
              <AccordionButton>
                <HeaderCliente cliente={item} />
              </AccordionButton>
              <AccordionPanel>
                <ActiveWorkContentTable obra={item} />
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ))}
      </div>
    </main>
  );
};

ActiveWorkTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      clienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      codigo: PropTypes.string.isRequired,
      nome: PropTypes.string.isRequired,
      produtos: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          grupoProduto: PropTypes.string.isRequired,
          volumeFaturado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          volumeNegociado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          dataNegociacao: PropTypes.string.isRequired,
          status: PropTypes.string.isRequired,
          porcentagem: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

export default ActiveWorkTable;
